import { useHistory } from 'react-router-dom';
import CategoryIcon from '@mui/icons-material/Category';
import MapIcon from '@mui/icons-material/Map';
import PersonIcon from '@mui/icons-material/Person';
import PublishIcon from '@mui/icons-material/Publish';
import SchoolIcon from '@mui/icons-material/School';
import SecurityIcon from '@mui/icons-material/Security';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import NavCard from './components/NavCard';
import { BEM_NAME_ELEMENTS } from './_const';
import {
	OBJ_APP_BRIDGES,
	OBJ_APP_HP,
} from 'pages/Bridges/ManagerValidation/_constants.js';

const Navigation = () => {
	const history = useHistory();

	return (
		<>
			<Typography
				variant='h6'
				color='primary'
				align='center'
				gutterBottom
			>
				Epic Administrative Tools
			</Typography>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'row',
					flexWrap: 'wrap',
					justifyContent: 'space-evenly',
					alignItems: 'stretch',
				}}
			>
				<NavCard
					title={'Job Category'}
					icon={<CategoryIcon color='error' />}
					description={
						'View Epic job category details.  Edit existing job categories or add new ones.'
					}
					navigation={
						<>
							<Button
								size='small'
								onClick={() =>
									history.push('./JobCategory/Search')
								}
								id={`${BEM_NAME_ELEMENTS.VIEW_NAVIGATION}__${BEM_NAME_ELEMENTS.FIELD_BUTTON}--job-category-search`}
							>
								Search
							</Button>
							<Button
								size='small'
								onClick={() =>
									history.push('./JobCategory/New')
								}
								id={`${BEM_NAME_ELEMENTS.VIEW_NAVIGATION}__${BEM_NAME_ELEMENTS.FIELD_BUTTON}--job-category-new`}
							>
								New
							</Button>
						</>
					}
				/>
				<NavCard
					title={'Job Category Mapping'}
					icon={<MapIcon color='error' />}
					description={
						'Review how HR departments and job titles map to Epic Job Categories.  Edit existing map entries or create new ones.'
					}
					navigation={
						<>
							<Button
								size='small'
								onClick={() =>
									history.push('./JobCategoryMapping/Search')
								}
								id={`${BEM_NAME_ELEMENTS.VIEW_NAVIGATION}__${BEM_NAME_ELEMENTS.FIELD_BUTTON}--job-category-mapping-search`}
							>
								Search
							</Button>
							<Button
								size='small'
								onClick={() =>
									history.push('./JobCategoryMapping/New')
								}
								id={`${BEM_NAME_ELEMENTS.VIEW_NAVIGATION}__${BEM_NAME_ELEMENTS.FIELD_BUTTON}--job-category-mapping-new`}
							>
								New
							</Button>
						</>
					}
				/>
				<NavCard
					title={'Training Track'}
					icon={<SchoolIcon color='error' />}
					description={
						'View Epic training tracks associated with job category mapping.  Edit existing training tracks or add new ones.'
					}
					navigation={
						<>
							<Button
								size='small'
								onClick={() =>
									history.push('./TrainingTrack/Search')
								}
								id={`${BEM_NAME_ELEMENTS.VIEW_NAVIGATION}__${BEM_NAME_ELEMENTS.FIELD_BUTTON}--training-track-search`}
							>
								Search
							</Button>
							<Button
								size='small'
								onClick={() =>
									history.push('./TrainingTrack/New')
								}
								id={`${BEM_NAME_ELEMENTS.VIEW_NAVIGATION}__${BEM_NAME_ELEMENTS.FIELD_BUTTON}--training-track-search`}
							>
								New
							</Button>
						</>
					}
				/>
				<NavCard
					title={'Bulk Upload'}
					icon={<PublishIcon color='error' />}
					description={
						'Bulk upload user job category assignment creations or edits.'
					}
					navigation={
						<>
							<Button
								size='small'
								onClick={() =>
									history.push('./BulkUpload/Upload')
								}
								id={`${BEM_NAME_ELEMENTS.VIEW_NAVIGATION}__${BEM_NAME_ELEMENTS.FIELD_BUTTON}--bulk-upload`}
							>
								Upload
							</Button>
						</>
					}
				/>
				<NavCard
					title={'User'}
					icon={<PersonIcon color='error' />}
					description={
						'View Epic system details by user. Validation reminder email triggers and training block lifts available.'
					}
					navigation={
						<>
							<Button
								size='small'
								onClick={() =>
									history.push(`./User/Search`, {
										systemID: OBJ_APP_BRIDGES.ID,
										systemName: OBJ_APP_BRIDGES.Name,
									})
								}
								id={`${BEM_NAME_ELEMENTS.VIEW_NAVIGATION}__${BEM_NAME_ELEMENTS.FIELD_BUTTON}--user--${OBJ_APP_BRIDGES.Name}`}
							>
								Search ({OBJ_APP_BRIDGES.Name})
							</Button>
							<Button
								size='small'
								onClick={() =>
									history.push(`./User/Search`, {
										systemID: OBJ_APP_HP.ID,
										systemName: OBJ_APP_HP.Name,
									})
								}
								id={`${BEM_NAME_ELEMENTS.VIEW_NAVIGATION}__${BEM_NAME_ELEMENTS.FIELD_BUTTON}--user--${OBJ_APP_HP.Name}`}
							>
								Search ({OBJ_APP_HP.Name})
							</Button>
						</>
					}
				/>
				<NavCard
					title={'Permissions'}
					icon={<SecurityIcon color='error' />}
					description={
						'Manage user permissions for the Epic Administrative Utilities.'
					}
					navigation={
						<>
							<Button
								size='small'
								onClick={() => history.push('./Security/View')}
							>
								Summary
							</Button>
							<Button
								size='small'
								onClick={() => history.push('./Security/Add')}
							>
								Add User
							</Button>
						</>
					}
				/>
			</Box>
		</>
	);
};

export default Navigation;
